// RevenueCat + native ads config.
// Paste dashboard values over any "Replace later" string when you have them.

export const REPLACE_LATER = "Replace later";

// Replace later — RevenueCat dashboard → API keys (public SDK keys).
export const REVENUECAT_APPLE_API_KEY = "Replace later"; // appl_...
export const REVENUECAT_GOOGLE_API_KEY = "Replace later"; // goog_...

// Replace later if you rename this entitlement in RevenueCat.
// Dashboard entitlement identifier should match, attached to product `no_ads`.
export const REVENUECAT_NO_ADS_ENTITLEMENT_ID = "no_ads";

// Replace later — AdMob / rewarded ads (Watch Ad). Billing does not need these.
export const ADMOB_IOS_APP_ID = "Replace later";
export const ADMOB_ANDROID_APP_ID = "Replace later";
export const ADMOB_REWARDED_AD_UNIT_ID = "Replace later";

export function isConfiguredSecret(value) {
    const text = String(value || "").trim();
    if (!text) {
        return false;
    }
    const lower = text.toLowerCase();
    return lower !== "replace later" && !lower.startsWith("replace later");
}

export function getRevenueCatApiKey(platform = "web") {
    if (platform === "ios") {
        return REVENUECAT_APPLE_API_KEY;
    }
    if (platform === "android") {
        return REVENUECAT_GOOGLE_API_KEY;
    }
    return "";
}

export function isRevenueCatKeyConfigured(platform = "web") {
    return isConfiguredSecret(getRevenueCatApiKey(platform));
}

export function isRewardedAdsConfigured() {
    return (
        isConfiguredSecret(ADMOB_REWARDED_AD_UNIT_ID) &&
        (isConfiguredSecret(ADMOB_IOS_APP_ID) ||
            isConfiguredSecret(ADMOB_ANDROID_APP_ID))
    );
}
